import { SET_SUBSCRIPTION_BUNDLE_FAILED } from "../actions/ActionConstant";
import { SET_SUBSCRIPTION_PRICE_START } from "../actions/ActionConstant";
import { SET_SUBSCRIPTION_PRICE_FAILED } from "../actions/ActionConstant";
import { USER_UNSUBSCRIBE_SUCCESS } from "../actions/ActionConstant";
import { USER_UNSUBSCRIBE_FAILED } from "../actions/ActionConstant";
import { USER_UNSUBSCRIBE_START } from "../actions/ActionConstant";
import { SET_SUBSCRIPTION_PRICE_SUCCESS } from "../actions/ActionConstant";
import { SET_SUBSCRIPTION_BUNDLE_SUCCESS } from "../actions/ActionConstant";
import { SET_SUBSCRIPTION_BUNDLE_START } from "../actions/ActionConstant";
import {
  FETCH_SUBSCRIPTION_START,
  FETCH_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_FAILURE,
  FETCH_SINGLE_SUBSCRIPTION_START,
  FETCH_SINGLE_SUBSCRIPTION_SUCCESS,
  FETCH_SINGLE_SUBSCRIPTION_FAILURE,
  SUBSCRIPTION_PAYMENT_STRIPE_START,
  SUBSCRIPTION_PAYMENT_STRIPE_SUCCESS,
  SUBSCRIPTION_PAYMENT_STRIPE_FAILURE,
  SUBSCRIPTION_PAYMENT_WALLET_START,
  SUBSCRIPTION_PAYMENT_WALLET_SUCCESS,
  SUBSCRIPTION_PAYMENT_WALLET_FAILURE,
  SUBSCRIPTION_AUTO_RENEWAL_START,
  SUBSCRIPTION_AUTO_RENEWAL_SUCCESS,
  SUBSCRIPTION_AUTO_RENEWAL_FAILURE,
  SUBSCRIPTION_PAYMENT_PAYPAL_START,
  SUBSCRIPTION_PAYMENT_PAYPAL_SUCCESS,
  SUBSCRIPTION_PAYMENT_PAYPAL_FAILURE,
  BUNDLE_MODAL_OPEN,
  BUNDLE_MODAL_CLOSE,
  FETCH_MY_ACTIVE_SUBSCRIPTION_START,
  FETCH_MY_ACTIVE_SUBSCRIPTION_SUCCESS,
  FETCH_MY_ACTIVE_SUBSCRIPTION_FAILURE,
  FETCH_ACTIVE_SUBSCRIBERS_START,
  FETCH_ACTIVE_SUBSCRIBERS_SUCCESS,
  FETCH_ACTIVE_SUBSCRIBERS_FAILURE
} from "../actions/ActionConstant";

const initialState = {
  subscription: {
    data: {},
    loading: true,
    error: false,
  },
  myActiveSubscription: {
    data: [],
    page: 1,
    limit: 9,
    hasNext: false,
    inputData: {},
    loading: true,
    error: false,
  },
  subscribers: {
    data: [],
    page: 1,
    limit: 9,
    hasNext: false,
    inputData: {},
    loading: true,
    error: false,
  },
  singleSubscription: {
    data: {},
    loading: true,
    error: false,
  },
  subPayStripe: {
    inputData: {},
    loading: true,
    error: false,
    success: {},
    buttonDisable: false,
    loadingButtonContent: null,
  },
  subPayWallet: {
    inputData: {},
    loading: true,
    error: false,
    success: {},
    buttonDisable: false,
    loadingButtonContent: null,
  },
  subscriptionRenew: {
    inputData: {},
    loading: true,
    error: false,
    success: {},
    buttonDisable: false,
    loadingButtonContent: null,
  },
  subscriptionPrice: {
    inputData: {},
    loading: false,
    error: false,
    success: {},
    buttonDisable: false,
    loadingButtonContent: null,
  },
  subscriptionBundle: {
    inputData: {},
    loading: true,
    error: false,
    success: {},
    buttonDisable: true,
    loadingButtonContent: null,
  },
  unsubscribe: {
    inputData: {},
    loading: true,
    error: false,
    success: {},
    buttonDisable: true,
    loadingButtonContent: null,
  },
  bundleModal: {
    open: false,
  },
};

const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_START:
      return {
        ...state,
        subscription: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscription: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        subscription: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case FETCH_SINGLE_SUBSCRIPTION_START:
      return {
        ...state,
        singleSubscription: {
          data: {},
          loading: true,
          error: false,
        },
        singleSubInputData: {
          data: action.data,
        },
      };
    case FETCH_SINGLE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        singleSubscription: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_SINGLE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        singleSubscription: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case SUBSCRIPTION_PAYMENT_STRIPE_START:
      return {
        ...state,
        subPayStripe: {
          inputData: action.data,
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Processing.. Please wait...",
        },
      };
    case SUBSCRIPTION_PAYMENT_STRIPE_SUCCESS:
      return {
        ...state,
        subPayStripe: {
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_PAYMENT_STRIPE_FAILURE:
      return {
        ...state,
        subPayStripe: {
          loading: true,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_PAYMENT_WALLET_START:
      return {
        ...state,
        subPayWallet: {
          inputData: action.data,
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Processing.. Please wait...",
        },
      };
    case SUBSCRIPTION_PAYMENT_WALLET_SUCCESS:
      return {
        ...state,
        subPayWallet: {
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_PAYMENT_WALLET_FAILURE:
      return {
        ...state,
        subPayWallet: {
          loading: true,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_AUTO_RENEWAL_START:
      return {
        ...state,
        subscriptionRenew: {
          inputData: action.data,
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Processing.. Please wait...",
        },
      };
    case SUBSCRIPTION_AUTO_RENEWAL_SUCCESS:
      return {
        ...state,
        subscriptionRenew: {
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_AUTO_RENEWAL_FAILURE:
      return {
        ...state,
        subscriptionRenew: {
          loading: true,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_PAYMENT_PAYPAL_START:
      return {
        ...state,
        subPayPaypal: {
          inputData: action.data,
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Processing.. Please wait...",
        },
      };
    case SUBSCRIPTION_PAYMENT_PAYPAL_SUCCESS:
      return {
        ...state,
        subPayPaypal: {
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SUBSCRIPTION_PAYMENT_PAYPAL_FAILURE:
      return {
        ...state,
        subPayPaypal: {
          loading: true,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SET_SUBSCRIPTION_BUNDLE_START:
      return {
        ...state,
        subscriptionBundle: {
          inputData: action.data,
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Processing.. Please wait...",
        },
      };
    case SET_SUBSCRIPTION_BUNDLE_SUCCESS:
      return {
        ...state,
        bundleModal: {
          open: false,
        },
        subscriptionBundle: {
          inputData: {},
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SET_SUBSCRIPTION_BUNDLE_FAILED:
      return {
        ...state,
        bundleModal: {
          open: true,
        },
        subscriptionBundle: {
          inputData: {},
          loading: false,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SET_SUBSCRIPTION_PRICE_START:
      return {
        ...state,
        subscriptionPrice: {
          inputData: {},
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Please Wait...",
        },
      };
    case SET_SUBSCRIPTION_PRICE_SUCCESS:
      return {
        ...state,
        subscriptionPrice: {
          inputData: {},
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: "Save",
        },
      };
    case SET_SUBSCRIPTION_PRICE_FAILED:
      return {
        ...state,
        subscriptionPrice: {
          inputData: {},
          loading: false,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: "Save",
        },
      };
    case USER_UNSUBSCRIBE_START:
      return {
        ...state,
        unsubscribe: {
          loading: true,
          inputData: action.data,
          error: null,
          data: {},
          buttonDisable: true,
          loadingButtonContent: "unsubscribing please wait...",
        },
      };
    case USER_UNSUBSCRIBE_SUCCESS:
      return {
        ...state,
        unsubscribe: {
          loading: false,
          inputData: {},
          error: null,
          data: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case USER_UNSUBSCRIBE_FAILED:
      return {
        ...state,
        unsubscribe: {
          loading: false,
          inputData: {},
          error: action.error,
          data: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case BUNDLE_MODAL_OPEN:
      return {
        ...state,
        bundleModal: {
          open: true,
        },
      };
    case BUNDLE_MODAL_CLOSE:
      return {
        ...state,
        bundleModal: {
          open: false,
        },
      };
    case FETCH_MY_ACTIVE_SUBSCRIPTION_START:
      return {
        ...state,
        myActiveSubscription: {
          ...state.myActiveSubscription,
          data: action.data && action.data.page != 1 ? state.myActiveSubscription.data : [],
          inputData: action.data,
          loading: true,
          error: null
        }
      };
    case FETCH_MY_ACTIVE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        myActiveSubscription: {
          ...state.myActiveSubscription,
          data: [
            ...state.myActiveSubscription.data,
            ...action.data.result
          ],
          page: action.data.metadata.pagination.page,
          hasNext: action.data.metadata.pagination.page < action.data.metadata.pagination.numberOfPages,
          inputData: {},
          loading: false,
          error: null
        }
      };
    case FETCH_MY_ACTIVE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        myActiveSubscription: {
          ...state.myActiveSubscription,
          loading: false,
          error: action.data
        }
      };
    case FETCH_ACTIVE_SUBSCRIBERS_START:
      return {
        ...state,
        subscribers: {
          ...state.subscribers,
          data: action.data && action.data.page != 1 ? state.subscribers.data : [],
          inputData: action.data,
          loading: true,
          error: null
        }
      }
    case FETCH_ACTIVE_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        subscribers: {
          ...state.subscribers,
          data: [
            ...state.subscribers.data,
            ...action.data.result
          ],
          page: action.data.metadata.pagination.page,
          hasNext: action.data.metadata.pagination.page < action.data.metadata.pagination.numberOfPages,
          inputData: {},
          loading: false,
          error: null
        }
      }
    case FETCH_ACTIVE_SUBSCRIBERS_FAILURE:
      return {
        ...state,
        subscribers: {
          ...state.subscribers,
          loading: false,
          error: action.data
        }
      }
    default:
      return state;
  }
};

export default SubscriptionReducer;
